export const regexName = "^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$";
export const regexSurname = "^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ -]+$";
export const regexEmail = "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$";
export const regexPhone = "^([+]?)[0-9]{9}([0-9]{2})?";
export const regexPhoneNational = "^(\\d{7}|\\d{9})$";

/**
 * National digits only (no country prefix). Drops pasted "+48 …" / "48…" when a full subscriber number was pasted.
 */
export function sanitizePolishPhoneInput(raw) {
  if (raw == null) {
    return "";
  }
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("48") && digits.length >= 11) {
    digits = digits.slice(2);
  }
  return digits.slice(0, 9);
}
